import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiAccordionStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            padding: variables.padding.inputsDefault,
            margin: '8px 0',
            '&:before': {
                display: 'none',
            },
        },
    },
});

export default createMuiAccordionStyles;
